const DocaIcon = ({ icon, iconSize }) => <i
	className={`doca-icon doca-icon--${iconSize} doca-icon__${icon}`}
/>;

export default DocaIcon;
